import qs from 'qs';

const baseUrl = process.env.TRACKING_PAGE_API_URL;

function fetchRequest(endpoint) {
  return Promise.resolve(fetch(`${baseUrl}${endpoint}`)).then((res) => {
    if (res.ok) {
      return res.json();
    }

    throw res;
  });
}

export function getTrackingPage(trackingPageId, orderId, zipCode, language) {
  const query = qs.stringify({ zipCode, language }, { addQueryPrefix: true });

  return fetchRequest(`/tracking-pages/${trackingPageId}/${orderId}${query}`);
}

export function getEmbeddedWidgetPage(embeddedWidgetId, orderId) {
  return fetchRequest(`/embedded-widgets/${embeddedWidgetId}/${orderId}`);
}
